// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IReportSchedulerResponseDto } from './IReportSchedulerResponseDto';
import {
    IReportSchedulerResponseDtoFromJSON,
    IReportSchedulerResponseDtoFromJSONTyped,
    IReportSchedulerResponseDtoToJSON,
    IReportSchedulerResponseDtoToJSONTyped,
} from './IReportSchedulerResponseDto';
import type { IPageableObject } from './IPageableObject';
import {
    IPageableObjectFromJSON,
    IPageableObjectFromJSONTyped,
    IPageableObjectToJSON,
    IPageableObjectToJSONTyped,
} from './IPageableObject';
import type { ISortOrder } from './ISortOrder';
import {
    ISortOrderFromJSON,
    ISortOrderFromJSONTyped,
    ISortOrderToJSON,
    ISortOrderToJSONTyped,
} from './ISortOrder';

/**
 * 
 * @export
 * @interface IPageReportSchedulerResponseDto
 */
export interface IPageReportSchedulerResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IPageReportSchedulerResponseDto
     */
    total_pages?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageReportSchedulerResponseDto
     */
    total_elements?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageReportSchedulerResponseDto
     */
    size?: number;
    /**
     * 
     * @type {Array<IReportSchedulerResponseDto>}
     * @memberof IPageReportSchedulerResponseDto
     */
    content?: Array<IReportSchedulerResponseDto>;
    /**
     * 
     * @type {number}
     * @memberof IPageReportSchedulerResponseDto
     */
    number?: number;
    /**
     * 
     * @type {Array<ISortOrder>}
     * @memberof IPageReportSchedulerResponseDto
     */
    sort?: Array<ISortOrder>;
    /**
     * 
     * @type {IPageableObject}
     * @memberof IPageReportSchedulerResponseDto
     */
    pageable?: IPageableObject;
    /**
     * 
     * @type {number}
     * @memberof IPageReportSchedulerResponseDto
     */
    number_of_elements?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IPageReportSchedulerResponseDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageReportSchedulerResponseDto
     */
    last?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageReportSchedulerResponseDto
     */
    empty?: boolean;
}

/**
 * Check if a given object implements the IPageReportSchedulerResponseDto interface.
 */
export function instanceOfIPageReportSchedulerResponseDto(value: object): value is IPageReportSchedulerResponseDto {
    return true;
}

export function IPageReportSchedulerResponseDtoFromJSON(json: any): IPageReportSchedulerResponseDto {
    return IPageReportSchedulerResponseDtoFromJSONTyped(json, false);
}

export function IPageReportSchedulerResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPageReportSchedulerResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'total_pages': json['totalPages'] == null ? undefined : json['totalPages'],
        'total_elements': json['totalElements'] == null ? undefined : json['totalElements'],
        'size': json['size'] == null ? undefined : json['size'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(IReportSchedulerResponseDtoFromJSON)),
        'number': json['number'] == null ? undefined : json['number'],
        'sort': json['sort'] == null ? undefined : ((json['sort'] as Array<any>).map(ISortOrderFromJSON)),
        'pageable': json['pageable'] == null ? undefined : IPageableObjectFromJSON(json['pageable']),
        'number_of_elements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
        'first': json['first'] == null ? undefined : json['first'],
        'last': json['last'] == null ? undefined : json['last'],
        'empty': json['empty'] == null ? undefined : json['empty'],
    };
}

export function IPageReportSchedulerResponseDtoToJSON(json: any): IPageReportSchedulerResponseDto {
    return IPageReportSchedulerResponseDtoToJSONTyped(json, false);
}

export function IPageReportSchedulerResponseDtoToJSONTyped(value?: IPageReportSchedulerResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalPages': value['total_pages'],
        'totalElements': value['total_elements'],
        'size': value['size'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(IReportSchedulerResponseDtoToJSON)),
        'number': value['number'],
        'sort': value['sort'] == null ? undefined : ((value['sort'] as Array<any>).map(ISortOrderToJSON)),
        'pageable': IPageableObjectToJSON(value['pageable']),
        'numberOfElements': value['number_of_elements'],
        'first': value['first'],
        'last': value['last'],
        'empty': value['empty'],
    };
}

